var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.877,
    height: 79.634,
    viewBox: "0 0 79.877 79.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34355",
    "data-name": "Group 34355",
    transform: "translate(1.75 1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29768",
    "data-name": "Group 29768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29765",
    "data-name": "Group 29765"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 26.158,
    transform: "translate(15.987 51.309)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 24.954,
    transform: "translate(15.987 61.709)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 28.567,
    transform: "translate(15.987 41.07)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 13.501,
    transform: "translate(34.297 31.311)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 13.501,
    transform: "translate(34.297 21.916)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29764",
    "data-name": "Group 29764",
    transform: "translate(6.095 3.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M2164.775,2850.773v-8.541a5.438,5.438,0,0,0-5.438-5.438h-4.454",
    transform: "translate(-2112.88 -2834.235)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M2054.037,2836.794h-4.206a5.438,5.438,0,0,0-5.438,5.438v52.6a5.438,5.438,0,0,0,5.438,5.438h41.02a5.438,5.438,0,0,0,5.438-5.438v-3.556",
    transform: "translate(-2044.393 -2834.235)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M2082.917,2830.063l2.843,6.352h16.919l2.843-6.352",
    transform: "translate(-2068.272 -2830.063)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M2156.962,2940.5",
    transform: "translate(-2114.168 -2898.516)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M2092.669,2830.254a10.657,10.657,0,0,0-10.657-10.657h-42.995a10.657,10.657,0,0,0-10.657,10.657v54.819a10.657,10.657,0,0,0,10.657,10.657h42.995a10.657,10.657,0,0,0,10.657-10.657v-11.836",
    transform: "translate(-2028.36 -2819.597)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29767",
    "data-name": "Group 29767",
    transform: "translate(46.457 12.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29766",
    "data-name": "Group 29766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M2179.86,2858.465l-19.952,35.546-9.343,6.953,1.069-11.6,19.952-35.546a4.744,4.744,0,0,1,6.459-1.815h0A4.744,4.744,0,0,1,2179.86,2858.465Z",
    transform: "translate(-2150.565 -2851.397)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 12.88,
    transform: "translate(21.536 19.125)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 12.88,
    transform: "translate(15.096 25.565)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.6aa0656cdf6e85062fd385e71bc241b0.svg";
export { ForwardRef as ReactComponent };